import { Component } from '@angular/core';
import { CustomerProductPrice, PriceLevelsComponent } from 'gung-standard';

@Component({
    selector: 'hl-display-price-levels',
    templateUrl: './hl-display-price-levels.component.html',
    styleUrls: ['./hl-display-price-levels.component.scss'],
    standalone: false
})
export class HlDisplayPriceLevelsComponent extends PriceLevelsComponent {
  ngOnInit(): void {
    super.ngOnInit();
  }

  override initPriceLevels(price: CustomerProductPrice, priceLevelsCurrentQty: number = undefined) {
    if (!price.backendPrice?.levels?.length) {
      return;
    }

    this.priceLevels = price.backendPrice.levels;

    if (this.priceLevels.length <= 1) {
      return;
    }

    // Always subscribe to cart. Use cart qty when product is in cart, otherwise fall back to priceLevelsCurrentQty.
    this.cartSubscription = this.cartService.getCurrentCart().subscribe(cart => {
      this.dataCart = cart.find(c => c.productId === price.productId);
      const effectiveQty = this.dataCart ? this.dataCart.qty : priceLevelsCurrentQty;

      this.currentPrice = 0;
      if (effectiveQty != null) {
        while (
          this.priceLevels[this.currentPrice + 1] &&
          effectiveQty >= this.priceLevels[this.currentPrice + 1].quantity
        ) {
          this.currentPrice++;
        }
      }
    });
  }
}
